/**
 * hub.coranchers.com API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface InvTranSuggestedEstimatedSalesDetModel { 
    invTranDetId?: number;
    invTranId?: number;
    itemNumber?: string | null;
    uOfM?: string | null;
    coverageDisplay?: string | null;
    customerOrderUnitsDisplay?: string | null;
    units?: number;
    quantity?: number;
    reference?: string | null;
    statusId?: number;
    itemDescription?: string | null;
    statusDisplay?: string | null;
}

